module.exports = __webpack_public_path__ + "img/aa_city_logo.445007d5.jpg";